import React from "react";
import logo from "../../assets/appAds/asaxiy-logo-white.svg";
import appStore from "../../assets/appAds/app-store.svg";
import googlePlay from "../../assets/appAds/google-play.svg";
import appGalary from "../../assets/appAds/app-gallery.svg";
import phoneApp from "../../assets/appAds/asaxiy-app.png";

// Shu yerga keldim

function AppAdvertisement() {
  return (
    <div className="w-screen mt-20  h-auto flex bg-white flex-col justify-center items-center">
      <div className="h-full rounded-xl bg-blueColor lg:w-11/12 mx-auto items-center flex justify-around shadow-md">
        <div className="flex h-full md:h-52 flex-col justify-evenly items-center">
          <div>
            <img src={logo} alt="logo" />
          </div>
          <div className="text-center">
            <p className="text-white normalFont text-xl">
              Sizning internet do'koningiz
            </p>
          </div>
          <div className="flex justify-evenly">
            <a href="#" className="m-3">
              <img
                className="hover:bg-black rounded-md"
                src={appStore}
                alt="appStore"
              />
            </a>
            <a href="#" className="m-3">
              <img
                className="hover:bg-black rounded-md"
                src={googlePlay}
                alt="googlePlayStore"
              />
            </a>
            <a href="#" className="m-3 ">
              <img
                className="hover:bg-black rounded-md"
                src={appGalary}
                alt="appGalary"
              />
            </a>
          </div>
        </div>
        <div>
          <img src={phoneApp} alt="phoneApp" />
        </div>
      </div>
    </div>
  );
}

export default AppAdvertisement;
